module.exports = __webpack_public_path__ + "0e058a4fc44d370a87c6a29df7d37339.svg";